export default __webpack_public_path__ + "static/media/tank.2a7d57e9.png";